module.exports = __webpack_public_path__ + "img/61.374f2306.jpg";